<template>
    <div class="tab-content-container">
        <div class="tab-header-container">
            <h2 class="form-label">Състав в екипа</h2>
            <LiteButton @click.native="shouldEditTeamMembers = true"
                        class="edit-button"
                        v-show="!shouldEditTeamMembers && isUserAdmin"
                        :hoverColor="'blue'"
                        :icon="'far fa-edit'">
            </LiteButton>
            <LiteButton @click.native="shouldEditTeamMembers = false"
                        style="font-size: 27px;"
                        class="edit-button"
                        v-show="shouldEditTeamMembers && isUserAdmin"
                        :hoverColor="'red'"
                        :icon="'far fa-window-close'">
            </LiteButton>
        </div>

        <hr class="form-line">

        <div v-if="!shouldEditTeamMembers">
            <div class="professions-counter"
                 v-for="profession in teamProfessions"
                 :key="profession.professionId">
                <ItemsCounter :maxCount="profession.maxWorkerCount"
                              :count="getWorkersCountForProfession(profession)"
                              :label="profession.professionName"/>
            </div>

            <Grid class="team-member-grid"
                  :config="config"
                  :gridData="teamMemberList"
                  :loading="isTeamLoading"
                  @row-clicked="rowClicked">
            </Grid>
        </div>

        <TeamMembersEditForm v-if="shouldEditTeamMembers" @saved-successful="membersSaved">
        </TeamMembersEditForm>
    </div>
</template>

<script>
    import Grid from "@/shared/components/grid/Grid";
    import teamMembersGridConfig from "@/components/team/form/team-members-list-grid.config";
    import redirectService from "@/services/redirect.service";
    import LiteButton from "@/shared/components/button/LiteButton"
    import {mapGetters} from "vuex";
    import {cloneDeep} from 'lodash';
    import TeamMembersEditForm from "@/components/team/form/TeamMembersEditForm";
    import utilService from "@/services/util.service";
    import ItemsCounter from "@/shared/components/ItemsCounter";

    export default {
        name: "TeamMembersList",
        components: {TeamMembersEditForm, Grid, LiteButton, ItemsCounter},
        created() {
            this.teamMemberList = this.getTeamMemberList();
        },
        data() {
            return {
                config: teamMembersGridConfig,
                teamMemberList: this.getTeamMemberList(),
                shouldEditTeamMembers: false
            }
        },
        methods: {
            rowClicked(row) {
                redirectService.redirectToWorkerProfile(row.id);
            },
            getTeamMemberList() {
                if (this.teamMembers && !this.isTeamLoading) {
                    const arrayTemp = cloneDeep(this.teamMembers).map((teamMember) => {
                        teamMember.id = teamMember.workerId;
                        return teamMember;
                    });
                    return utilService.sortArrayByNumberSelector(arrayTemp, 'professionOrderIndex', false);
                }
                return [];
            },
            membersSaved() {
                this.shouldEditTeamMembers = false;
            },
            getWorkersCountForProfession(profession) {
                return this.teamMemberList.filter((teamMember) => teamMember.professionId === profession.professionId).length;
            }
        },
        computed: {
            ...mapGetters(['teamMembers', 'isTeamLoading', 'teamProfessions', 'isUserAdmin']),
        },
        watch: {
            teamMembers: {
                handler() {
                    this.teamMemberList = this.getTeamMemberList();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    @import '../../../css/shared/tabs.css';

    .team-member-grid {
        margin-bottom: 50px;
        display: inline-block;
        width: 100%;
    }

    .professions-counter {
        width: fit-content;
        display: inline-block;
        margin: 20px;
        font-size: 22px;
    }
</style>
